var map = {
	"./celebrate.svg": "b1e8",
	"./curious.svg": "f73a",
	"./empty.svg": "46df",
	"./insightful.svg": "7cae",
	"./like.svg": "0888",
	"./love.svg": "8faa",
	"./support.svg": "2598"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "08b0";